/**
 * 屏蔽
 */
var AUTHORIZE_ADMIN= 'ÔÖÏÍØ·qce'; // asclaw@123
var AUTHORIZE_STAFF= 'ÔÖÏÍØ·qce';	// asclaw@123
var AUTHORIZE_SNAP="ÔÖÏÍØ·qce";  // asclaw@123

/**
 * 字串加密
 */
function encrypt(text) {
  var output = "";
  for (var i = 1; i < text.length; i++) {
    output += String.fromCharCode(text.charCodeAt(i) + text.charCodeAt(i - 1));
  }
  return output;
}
/**
 * 访问授权
 */
function authorize(CODE){
  if(CODE == AUTHORIZE_ADMIN){
    //$.cookie('AUTHORIZE', 'ADIMN', { expires: 60, path: '/' });
    setCookie('AUTHORIZE', 'ADMIN', 60);
  } else if(CODE == AUTHORIZE_STAFF){
    //$.cookie('AUTHORIZE', 'STAFF', { expires: 30, path: '/' });
    setCookie('AUTHORIZE', 'STAFF', 30);
  } else if(CODE == AUTHORIZE_SNAP){
    //$.cookie('AUTHORIZE', 'SNAP', { expires: 1, path: '/' });
    setCookie('AUTHORIZE', 'SNAP', 1);
  } else {
  	removeCookie('AUTHORIZE');
  }
}

 

/**
 * 获取HTTP请求的Referer
 * @ishost 布尔类型 Referer为空时是否返回Host（网站首页地址）
 */
function getReferer() {
    if (document.referrer) {
        return document.referrer;
    }
  return "";
}

function getUrl(){
	return window.location.href;
}

/**
 * 是否是授权页面
 */
function isAuthorizationPage(){
  var url = getUrl();	
  return url.indexOf("authorization") > 0; 	// 非授权页面
}

/**
 * 是否已授权
 */
function isAuthorize(){
  var authorize = getCookie("AUTHORIZE");
  return authorize != ""; 
}

/**
 * 是否是要屏蔽的语言
 */
function isLanguage(){
  var language = getCookie("shieldzh");
  if(language !=""){
    console.log("shield 屏蔽语言 Cookie");
    return true;
  }
  
  language = (navigator.browserLanguage || navigator.language).toLowerCase();
  if(language == "zh-cn"){ 	// 要屏蔽的语言
    setCookie("shieldzh", "zh", 365);
    console.log("shield 屏蔽语言");
    return true;
  }
  return false;
}


 /**
 * 是否是要屏蔽的国家
 */
function isCountry(){
  var result = false;
  //已经判断过的国家不用再判断
  var country = getCookie("shieldcn");
  if(country == ""){
      // 判断国家
      $.ajaxSettings.async = false;  //设为同步请求
      $.getJSON("http://ipinfo.io", function (data) {
          if(data.country == "CN"){
             setCookie("shieldcn", "cn", 365);
             result = true;
           }
        });
       $.ajaxSettings.async = true;  //设为同步请求
  }
  return result;
}

/**
 * IP是否是代理
 */
function isProxy(){
  //已经判断过的国家不用再判断
  var country = getCookie("shieldcn");
  var vpn = getCookie("shieldvpn");
  if(country !="" || vpn !=""){
    console.log("shield 屏蔽国家 Cookie");
    return true;
  }
  
  var result = false;
  $.ajaxSettings.async = false;  //设为同步请求
  $.getJSON("https://proxycheck.io/v2/?key=public-24a57y-68m11a-ba2054&vpn=1&asn=1", function(json) {
    if (json.status == "warning" || json.status == "ok") {
      if(json[json.ip].country == "China"){
      	setCookie("shieldcn", "cn", 365);
        result = true;
        console.log("shield 屏蔽国家");
      }
      /*
      if(json[json.ip].proxy == "yes"){
        setCookie("shieldps", "ps", 365);
        result = true;
        console.log("屏蔽 VPN");
      }
      */
    }
 });
  $.ajaxSettings.async = true;  //设为同步请求
  return result;
}



/**
 * 屏蔽开关 - 要屏蔽的内容
 */
function shield(){
  var isAuthPage = isAuthorizationPage();	// 是否是授权页面
  var isHadAuthorize = isAuthorize(); // 是否是已授权
  if(!isHadAuthorize && !isAuthPage) {
    if(isLanguage() || isProxy()){  	// 要屏蔽的语言、国家和IP
      window.location.href = "/pages/authorization";
      return;
    }
  }
}
//shield();   // 开关